import { render } from "./FullYearCalendar.vue?vue&type=template&id=2b021a76&scoped=true"
import script from "./FullYearCalendar.vue?vue&type=script&lang=js"
export * from "./FullYearCalendar.vue?vue&type=script&lang=js"

import "./FullYearCalendar.vue?vue&type=style&index=0&id=2b021a76&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b021a76"]])

export default __exports__